export default __webpack_public_path__ + "static/media/car.b05291c2.svg";